import React from 'react';
import { useTranslation } from 'react-i18next';
import { SquareTerminal } from 'lucide-react';
import Tooltip from '../../ui/Tooltip';
import { openInTerminal } from './openInTerminal';
import { resolveRunCwd } from './runApi';

/**
 * "Open in terminal": the repo's local clone (or a configuration's `cwd`
 * inside it) in a new Terminal tab with the default shell. Disabled with
 * "Link a local clone first" while the repo has no folder on this device.
 */
export default function OpenInTerminalButton({ repoPath, cwd = null, projectName = '', label, className = '', testId = 'open-in-terminal' }) {
  const { t } = useTranslation();
  const disabled = !repoPath;
  const tip = disabled ? t('projects.run.terminal.needsClone') : t('projects.run.terminal.open');
  const open = async () => {
    if (disabled) return;
    let dir = repoPath;
    if (cwd) {
      try {
        dir = await resolveRunCwd(repoPath, cwd);
      } catch {
        dir = repoPath;
      }
    }
    openInTerminal({ cwd: dir, repoPath, projectName, label });
  };
  return (
    <Tooltip content={tip} side="bottom">
      <span className="pj-run-term-wrap">
        <button
          type="button"
          className={`graph-icon-btn pj-run-btn ${className}`}
          onClick={open}
          aria-label={t('projects.run.terminal.open')}
          data-testid={testId}
          data-cwd={cwd || ''}
          data-tooltip={tip}
          disabled={disabled}
        >
          <SquareTerminal size={13} />
        </button>
      </span>
    </Tooltip>
  );
}
